import { useQuery } from '@tanstack/react-query';
import { errorMessages } from '~/constants/errorMessages.ts';
import api from '~/libs/api';
import { TQuestionnaire } from './types';
import { ClientTypes } from '~/constants/clientTypes';
import { useSelector } from 'react-redux';
import { RootState } from '~/store/store';

const getQuestionnaire = (token: string, clientType?: ClientTypes | string) => async () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
  try {
    const { data } = await api.get(
      `/dictionary-service/dictionary/questionnaire?client-type=${clientType}`,
      { headers }
    );
    return data;
  } catch {
    throw Error(errorMessages.SERVICE_UNAVAILABLE);
  }
};

export const useQuestionnaireQuery = (clientType?: ClientTypes) => {
  const token = useSelector((state: RootState) => state.users.token);

  const { data, error, isLoading, isError } = useQuery<TQuestionnaire[]>({
    queryKey: ['questionnaire'],
    queryFn: getQuestionnaire(token, clientType),
    staleTime: 30 * 60 * 1000,
  });

  return { questions: data ?? [], error, isLoading, isError };
};
